<div class="move-to-line">
  <header class="head">
    <h2 class="title">Move to line</h2>
    <p class="copy">Pick another Service Line on this plan.</p>
  </header>

  @if ($loading()) {
    <p class="status">Loading…</p>
  } @else if ($empty()) {
    <p class="status">No other Service Lines on this plan.</p>
  } @else {
    <ul class="options">
      @for (line of $lines(); track line._id) {
        <li>
          <button type="button" class="option" (click)="pick(line._id)">{{ line.name }}</button>
        </li>
      }
    </ul>
  }
</div>
